import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["work_experience", "empty"];
import React, { Fragment, useMemo } from "react";
import { formatDatesWithCurrent } from "../../helpers";
export var WorkExperience = function WorkExperience(_ref) {
  var work_experience = _ref.work_experience,
      empty = _ref.empty,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var regularWork = useMemo(function () {
    return work_experience.filter(function (_ref2) {
      var previous = _ref2.previous,
          omit = _ref2.omit;
      return !previous && !omit;
    });
  }, [work_experience]);
  var additionalWork = useMemo(function () {
    return work_experience.filter(function (_ref3) {
      var previous = _ref3.previous,
          omit = _ref3.omit;
      return previous && !omit;
    });
  }, [work_experience]);
  if (!regularWork.length && !additionalWork.length && !empty) return null;
  return /*#__PURE__*/React.createElement("section", _extends({
    className: "work-experience"
  }, otherProps), /*#__PURE__*/React.createElement("h2", null, "Work Experience"), empty && /*#__PURE__*/React.createElement("p", null, "Click here to add your work experience"), /*#__PURE__*/React.createElement("dl", {
    className: "current"
  }, regularWork.map(function (_ref4) {
    var company = _ref4.company,
        title = _ref4.title,
        location = _ref4.location,
        date_range = _ref4.date_range,
        quick_details = _ref4.quick_details,
        accomplishments = _ref4.accomplishments,
        skills_used = _ref4.skills_used,
        is_current = _ref4.is_current;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "".concat(company, "/").concat(title, "/").concat(location, "/").concat(date_range, "/").concat(is_current)
    }, false && /*#__PURE__*/React.createElement("dt", is_current && {
      current: true
    }, /*#__PURE__*/React.createElement("span", {
      "data-what": "company"
    }, company), /*#__PURE__*/React.createElement("span", {
      "data-what": "title"
    }, title)), /*#__PURE__*/React.createElement("dd", is_current && {
      current: true
    }, /*#__PURE__*/React.createElement("section", {
      className: "summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "work-company"
    }, company), /*#__PURE__*/React.createElement("div", {
      className: "work-location"
    }, location), /*#__PURE__*/React.createElement("div", {
      className: "work-title"
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "work-dates"
    }, formatDatesWithCurrent({
      date_range: date_range,
      is_current: is_current
    }, "Present"))), /*#__PURE__*/React.createElement("section", {
      className: "details"
    }, /*#__PURE__*/React.createElement("p", {
      className: "work-companydesc quick"
    }, quick_details)), accomplishments && /*#__PURE__*/React.createElement("ul", {
      className: "work-bullets"
    }, accomplishments.map(function (accomplishment) {
      return /*#__PURE__*/React.createElement("li", {
        key: accomplishment
      }, accomplishment);
    }), skills_used && skills_used.length !== 0 && /*#__PURE__*/React.createElement("li", {
      "data-skills": true
    }, /*#__PURE__*/React.createElement("strong", null, "Skills/Technologies:"), " ", skills_used.join(", "))), !accomplishments && skills_used && skills_used.length !== 0 && /*#__PURE__*/React.createElement("p", {
      "data-skills": true
    }, /*#__PURE__*/React.createElement("strong", null, "Skills/Technologies:"), " ", skills_used.join(", "))));
  })), !!additionalWork.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, "Previous Employment"), /*#__PURE__*/React.createElement("dl", {
    className: "previous"
  }, additionalWork.map(function (_ref5) {
    var company = _ref5.company,
        location = _ref5.location,
        title = _ref5.title,
        date_range = _ref5.date_range;
    return /*#__PURE__*/React.createElement("dd", {
      className: "summary",
      key: "".concat(company, "/").concat(title, "/").concat(location, "/").concat(date_range)
    }, /*#__PURE__*/React.createElement("div", {
      className: "work-company"
    }, company), /*#__PURE__*/React.createElement("div", {
      className: "work-location"
    }, location), /*#__PURE__*/React.createElement("div", {
      className: "work-title"
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "work-dates"
    }, formatDatesWithCurrent({
      date_range: date_range
    })));
  }))));
};